export default {
  QUOTES: "विचार",
  QUOTE: "विचार",
};
